module.exports = __webpack_public_path__ + "static/media/Layer 2.0419f7d1.png";